export const site = {
  name: "蝌蚪爆料",
  slogan: "点开蝌蚪爆料，一手消息不间断",
  intro:
    "蝌蚪爆料是一个专注于现场与内幕的爆料资讯站，把散落各处的线索、画面和讨论整理成结构清晰的内容流，让想第一时间掌握动态的人不再来回翻找。",
  email: "contact@keloubaoliao.example.com",
  submitEmail: "tips@keloubaoliao.example.com",
  mission:
    "让每一条值得关注的爆料，都能被快速、准确、有条理地看见。我们不追热度本身，只追热度背后那条查得到来路的线索。",
};

export const stats = [
  { label: "每日更新快讯", value: "120+" },
  { label: "在跟进的现场线索", value: "38" },
  { label: "累计爆料条目", value: "9600+" },
  { label: "日均阅读人次", value: "26 万" },
];

export interface FlashItem {
  id: string;
  time: string;
  text: string;
  tag: string;
}

export const quickFlash: FlashItem[] = [
  { id: "f1", time: "10:12", text: "综艺录制现场路透持续发酵，讨论集中在舞台调度细节", tag: "现场" },
  { id: "f2", time: "09:48", text: "折叠屏新机预热物料再添一版，铰链形容被反复解读", tag: "内幕" },
  { id: "f3", time: "09:05", text: "新车路测画面更新，尾部造型成为新一轮猜测焦点", tag: "内幕" },
  { id: "f4", time: "08:30", text: "短剧通告单话题升温，从业者开始分享真实拍摄节奏", tag: "热议" },
  { id: "f5", time: "08:02", text: "老夜市回归后的动线改造获好评，摊主谈经营新规", tag: "生活" },
  { id: "f6", time: "07:41", text: "音乐节剪影图引发逐帧比对，开票节奏随之提前", tag: "现场" },
];

export interface Testimonial {
  name: string;
  role: string;
  text: string;
  initial: string;
}

export const testimonials: Testimonial[] = [
  {
    name: "阿柴",
    role: "资深吃瓜群众",
    text: "以前找一条爆料要翻五六个群，现在直接在蝌蚪爆料按分类刷，时间线一目了然，省事不少。",
    initial: "柴",
  },
  {
    name: "小林",
    role: "数码爱好者",
    text: "科技内幕这个栏目做得挺克制，路测画面会标注哪些能确认、哪些只是推测，不会为了流量硬下结论。",
    initial: "林",
  },
  {
    name: "Yuki",
    role: "内容运营",
    text: "投稿入口很顺，把线索整理好发过去，编辑会回一条确认。对做内容的人来说，这种反馈很难得。",
    initial: "Y",
  },
  {
    name: "老周",
    role: "行业观察者",
    text: "我最常看行业风向那一栏，它会把零散的品牌动作串起来讲，读完对整个赛道的判断会更清楚。",
    initial: "周",
  },
  {
    name: "点点",
    role: "城市漫游者",
    text: "生活新鲜事是我每天必刷的，夜市、赛事、市集这些内容做得很有画面感，看完就想出门。",
    initial: "点",
  },
  {
    name: "麦麦",
    role: "追剧观众",
    text: "娱乐现场的花絮整理得很细，连中场补妆这种细节都有，看正片的时候理解完全不一样了。",
    initial: "麦",
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "蝌蚪爆料的快讯多久更新一次？",
    a: "我们以“当日多条”的节奏更新，重点线索会优先进入首页的实时快讯流。遇到重要现场时，会先发一条简讯，再补上完整的经过梳理，保证你第一时间知道，也能事后看清楚。",
  },
  {
    q: "网站上的爆料内容是怎么确认的？",
    a: "每条内容都会标注线索来源类型，例如现场观众线索、网友记录或渠道实拍。对于无法核实的部分，我们会在正文里明确说明，而不是当成既定事实发布。",
  },
  {
    q: "普通用户可以投稿吗？怎么投？",
    a: "可以。你可以在联系与投稿页面填写线索内容，也可以直接发送邮件。请在描述里写清时间、地点和你亲眼看到的部分，编辑会在核对后回复是否采用。",
  },
  {
    q: "为什么有的爆料只有快讯，没有完整文章？",
    a: "爆料在早期往往只有零散信息。为了保证准确，我们会先以快讯形式记录，等线索足够完整、可以串成时间线时，再整理成完整文章。这样既快，也不会因为赶时间而失实。",
  },
  {
    q: "内容可以转载吗？",
    a: "欢迎在注明来源并保留原文链接的前提下引用。若需要整篇转载或商业用途，请先通过联系页面与我们沟通，我们会尽快回复。",
  },
  {
    q: "网站上会出现收费内容吗？",
    a: "目前的快讯与爆料内容均可免费阅读。如果未来推出会员或增值服务，我们会提前明确告知，不会对现有免费内容做隐藏处理。",
  },
];

export const siteValues = [
  {
    icon: "ri-flashlight-line",
    title: "先到一步",
    desc: "快讯优先，重要现场先发简讯，让关注的人不错过第一波信息。",
  },
  {
    icon: "ri-shield-check-line",
    title: "能核才发",
    desc: "分不清真假的部分会标注“待核实”，不把猜测包装成结论。",
  },
  {
    icon: "ri-links-line",
    title: "串成线索",
    desc: "零散信息会被整理成时间线，让一件事情的来龙去脉看得明白。",
  },
  {
    icon: "ri-user-voice-line",
    title: "与读者共建",
    desc: "投稿入口长期开放，读者的线索是内容的重要来源。",
  },
];

export const contentPrinciples = [
  {
    no: "01",
    title: "来源可追溯",
    desc: "每条爆料都会交代线索类型，画面与描述分开呈现，读者可以自行判断可信度。",
  },
  {
    no: "02",
    title: "区分事实与推测",
    desc: "能确认的写成事实，无法确认的明确标注，不让推测混进正文的陈述里。",
  },
  {
    no: "03",
    title: "尊重当事人",
    desc: "内容以事件与流程为主，不针对具体个人的私生活展开，也不会发布无法核实的负面指控。",
  },
  {
    no: "04",
    title: "持续跟进",
    desc: "已发布的内容不是终点，出现新进展时会补充更新，并在时间线上标注变化。",
  },
];